<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>
  <p>Add Card {{ card.token }} to cashback a group</p>

  <div>
    <ng-container *ngIf="!isLoadingCashbackGroups; else loading">
      <mat-form-field>
        <mat-select [(ngModel)]="cashbackGroup">
          <mat-option *ngFor="let cmp of cashbackGroups" [value]="cmp" [ngStyle]="{'color': (cmp.isEnabledCalc) ? 'red' : 'black'}" >{{ cmp.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
    <ng-template #loading>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </ng-template>
  </div>


  <br /><br />


</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="onNoClick()" cdkFocusInitial color="basic">Cancel</button>
  <button mat-raised-button (click)="onYesClick()" color="primary" [disabled]="!cashbackGroup">Add</button>
</div>

